import { r as p, a as c, h as n, g as h, b as l, i as a } from "./index-6e735f92.js";
import { h as u } from "./constants-3d8016e3-3c080f00.js";
import "react";
import "react/jsx-runtime";
import "react-dom";
const f = ':host{display:block;position:relative;--nylas-primary:#2563eb;--nylas-error:#cc4841;--nylas-error-pressed:#992222;--nylas-wraning:#f06c00;--nylas-success:#16a392;--nylas-info:#2b8fc2;--nylas-base-0:#ffffff;--nylas-base-25:#fcfcfd;--nylas-base-50:#f8f9fc;--nylas-base-100:#eaecf5;--nylas-base-200:#d5d9eb;--nylas-base-300:#b3b8d8;--nylas-base-400:#717bbc;--nylas-base-500:#4e5ba6;--nylas-base-600:#3e4784;--nylas-base-700:#263f72;--nylas-base-800:#293056;--nylas-base-900:#101323;--nylas-base-950:#0e101b;--nylas-color-blue-100:#e0e6f9;--nylas-border-radius:0.25rem;--nylas-border-radius-2x:0.5rem;--nylas-border-radius-3x:0.75rem;--nylas-font-family:"Inter", sans-serif;--nylas-color-black:#000000;--nylas-color-grey-900:#2c2c2c;--nylas-color-grey-800:#4b4b4b;--nylas-color-grey-700:#6e6e6e;--nylas-color-grey-600:#8e8e8e;--nylas-color-grey-500:#b3b3b3;--nylas-color-grey-400:#cacaca;--nylas-color-grey-300:#e1e1e1;--nylas-color-grey-200:#eaeaea;--nylas-color-grey-100:#f5f5f5;--nylas-color-grey-50:#fbfcfe;--nylas-color-white:#ffffff;--nylas-color-red-900:#992222;--nylas-color-red-700:#cc4841;--nylas-color-red-500:#ff786a;--nylas-color-red-300:#ffa79e;--nylas-color-red-100:#ffc5bf;--nylas-color-red-50:#ffeae8;--nylas-color-blue-900:#213571;--nylas-color-blue-700:#314fa9;--nylas-color-blue-500:#4169e1;--nylas-color-blue-300:#bdccf9;--nylas-color-blue-100:#e0e6f9;--nylas-color-blue-50:#f6f8fd;--nylas-color-yellow-900:#7c6506;--nylas-color-yellow-700:#c29f09;--nylas-color-yellow-500:#f7c90b;--nylas-color-yellow-300:#f9de70;--nylas-color-yellow-100:#fceba9;--nylas-color-yellow-50:#fdf4ce;--nylas-color-green-900:#0e6b60;--nylas-color-green-700:#16a392;--nylas-color-green-500:#17c3b2;--nylas-color-green-300:#74dbd1;--nylas-color-green-100:#a2e7e0;--nylas-color-green-50:#d1f3f0;--nylas-color-purple-900:#643554;--nylas-color-purple-700:#954f7d;--nylas-color-purple-500:#c769a7;--nylas-color-purple-300:#dda5ca;--nylas-color-purple-100:#e0bdd6;--nylas-color-purple-50:#e9dde5;--nylas-color-sky-900:#20698f;--nylas-color-sky-700:#2b8fc2;--nylas-color-sky-500:#6dceff;--nylas-color-sky-300:#8fdaff;--nylas-color-sky-100:#b8e7ff;--nylas-color-sky-50:#d9f2ff}@media screen and (max-width: 768px){:host{position:unset}}.dropdown{display:inline-block;width:inherit}.dropbtn{color:var(--nylas-base-800);padding:10px;font-size:16px;font-family:var(--nylas-font-family);cursor:pointer;display:flex;gap:0.5rem;background:transparent;border:none;border-radius:var(--nylas-border-radius-2x);padding:14px 16px;border-radius:var(--nylas-border-radius-2x)}.dropbtn.focus{background:transparent}.dropbtn:hover,.dropbtn:active{outline:1px solid var(--nylas-primary)}.dropbtn:active{outline:2px solid var(--nylas-primary)}.dropbtn span.chevron{display:flex;align-self:center}.dropbtn span.open{transform:rotate(90deg)}.dropbtn span.closed{transform:rotate(270deg)}.dropbtn span.selected-option{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;max-width:144px;font-size:14px;line-height:20px}@media screen and (max-width: 768px){.dropbtn span.selected-option{max-width:124px;font-size:16px}}.dropdown-content{display:block;margin-top:0.5rem;background-color:var(--nylas-base-0);max-width:306px;width:max-content;max-height:336px;overflow:auto;z-index:1;border-radius:4px;position:absolute;box-shadow:0px 4px 6px -2px rgba(0, 0, 0, 0.05);box-shadow:0px 10px 15px -3px rgba(0, 0, 0, 0.1)}@media screen and (max-width: 768px){.dropdown-content{right:0;width:325px;max-width:unset}}.search-box{border-bottom:1px solid var(--nylas-base-200);padding:10px;position:sticky;top:0;background:var(--nylas-base-0)}.search-box .icon{position:absolute;top:1.25rem;left:1.25rem;color:var(--nylas-base-300)}.dropdown-content ul{padding:0;list-style-type:none;color:var(--nylas-base-900);max-height:336px}.dropdown-content ul li{padding:16px, 12px, 16px, 12px;color:var(--nylas-base-900);padding:12px 16px;text-decoration:none;display:block;font-family:inherit;font-size:14px;font-weight:400;line-height:20px;letter-spacing:0px;text-align:left;cursor:pointer}.dropdown-content ul li:hover,.dropdown-content ul li:focus{background-color:var(--nylas-base-100)}.dropdown-content .selected{background-color:#e7e7e7}input[type=text]{width:-webkit-fill-available;padding:inherit;border:1px solid #ccc;border-radius:4px;position:sticky;background:no-repeat scroll 7px 7px;padding-left:30px;background-size:16px 16px}', m = f, b = class {
  constructor(e) {
    p(this, e), this.inputOptionChanged = c(this, "inputOptionChanged", 7), this.name = void 0, this.options = [], this.defaultInputOption = void 0, this.inputValue = void 0, this.pluralizedLabel = "", this.filterable = !1, this.selectedOption = this.defaultInputOption || null, this.isOpen = !1, this.typedValue = "", this.filteredOptions = [...this.options], this.ariaActivedescendant = "", this.shouldAutoScroll = !1;
  }
  optionsChangedHandler(e, t) {
    e !== t && (this.filteredOptions = this.getFilteredOptions(e));
  }
  defaultSelectedOptionChangedHandler(e, t) {
    (e == null ? void 0 : e.label) !== (t == null ? void 0 : t.label) && (this.selectedOption = e);
  }
  inputValueChangedHandler(e, t) {
    e !== t && (this.filteredOptions = this.getFilteredOptions(this.options));
  }
  componentWillLoad() {
    this.filteredOptions = this.getFilteredOptions(this.options), !this.selectedOption && this.defaultInputOption && (this.selectedOption = this.defaultInputOption), !this.selectedOption && this.options.length > 0 && (this.selectedOption = this.options[0]);
  }
  getFilteredOptions(e) {
    return this.filterable ? e.filter((t) => {
      var o, i, s, r;
      return ((i = t == null ? void 0 : t.value) == null ? void 0 : i.toString().toLowerCase().includes((o = this.typedValue) == null ? void 0 : o.toLowerCase())) || ((r = t == null ? void 0 : t.label) == null ? void 0 : r.toLowerCase().includes((s = this.typedValue) == null ? void 0 : s.toLowerCase()));
    }) : e;
  }
  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }
  selectOption(e) {
    this.selectedOption = e, this.toggleDropdown(), this.inputOptionChanged.emit({
      value: e.value,
      name: this.name
    });
  }
  handleOnInput(e) {
    const t = e.target.value;
    this.typedValue = t;
    const o = this.options.findIndex((i) => i.label.toLowerCase().includes(t.toLowerCase()));
    o > -1 && this.scrollToViewWithinParent(o), this.inputOptionChanged.emit({
      value: t,
      name: this.name
    });
  }
  scrollToViewWithinParent(e) {
    var d;
    const t = this.options[e], o = (d = this.el.shadowRoot) == null ? void 0 : d.getElementById(t.value.toString()), i = this.optionsRef;
    if (this.ariaActivedescendant = t.value.toString(), !o || !i)
      return;
    const s = o.getBoundingClientRect(), r = i.getBoundingClientRect();
    s.top < r.top ? i.scrollTop -= r.top - s.top : s.bottom > r.bottom && (i.scrollTop += s.bottom - r.bottom);
  }
  handleSelectButtonKeyDown(e) {
    var t;
    switch (e.key) {
      case "ArrowDown":
      case "Enter":
        e.preventDefault(), this.isOpen || this.toggleDropdown(), (t = this.inputRef) == null || t.focus();
        break;
      case "Escape":
        this.isOpen = !1;
        break;
    }
  }
  handleClick(e) {
    if (this.isOpen) {
      const t = e.target.value, o = this.options.findIndex((i) => i.label.toLowerCase().includes(t.toLowerCase()));
      o > -1 && setTimeout(() => {
        this.scrollToViewWithinParent(o);
      }, 10);
    }
  }
  handleListboxKeydown(e) {
    var i, s;
    const t = this.filteredOptions, o = t.findIndex((r) => r.value === this.ariaActivedescendant);
    if (e.key === "ArrowDown" || e.key === "Tab" && !e.shiftKey) {
      if (e.preventDefault(), o === t.length - 1) {
        this.ariaActivedescendant = "", (i = this.inputRef) == null || i.focus();
        return;
      }
      const r = o + 1 < t.length ? o + 1 : 0;
      this.ariaActivedescendant = t[r].value, this.focusOption(r);
    } else if (e.key === "ArrowUp" || e.key === "Tab" && e.shiftKey) {
      if (e.preventDefault(), o === 0) {
        this.ariaActivedescendant = "", (s = this.inputRef) == null || s.focus();
        return;
      }
      const r = o - 1 >= 0 ? o - 1 : t.length - 1;
      this.ariaActivedescendant = t[r].value, this.focusOption(r);
    } else
      e.key === "Enter" ? (e.preventDefault(), this.ariaActivedescendant && this.selectOption(t[o])) : e.key === "Escape" && (this.isOpen = !1);
  }
  focusOption(e) {
    var s;
    const t = this.filteredOptions[e];
    if (!t)
      return;
    const o = t.value, i = (s = this.el.shadowRoot) == null ? void 0 : s.getElementById(o);
    i && (i.focus(), i.scrollIntoView({ behavior: "smooth", block: "nearest" }));
  }
  handleComboboxKeyDown(e) {
    if (e.key === "ArrowDown" || e.key == "Tab" && !e.shiftKey) {
      if (e.preventDefault(), !this.isOpen) {
        this.isOpen = !0, this.shouldAutoScroll = !0;
        return;
      }
      this.ariaActivedescendant = this.filteredOptions[0].value, this.focusOption(0);
    } else
      e.key === "ArrowUp" || e.key === "Tab" && e.shiftKey ? (e.preventDefault(), this.ariaActivedescendant = this.filteredOptions[this.filteredOptions.length - 1].value, this.focusOption(this.filteredOptions.length - 1)) : e.key === "Escape" && (this.isOpen = !1);
  }
  handleOutsideClick(e) {
    !e.composedPath().includes(this.el) && this.isOpen && (this.isOpen = !1);
  }
  render() {
    return n("div", { key: "973305bea60fe93f743e190aa210f2da4cd497fe", class: "dropdown", part: "id_dropdown" }, n("input", { key: "66891f091568906d5e51fbaebdb0d064b446580a", type: "text", name: this.name, id: this.name, part: "id_dropdown-input", class: { dropbtn: !0, open: this.isOpen }, value: this.inputValue, onClick: (e) => {
      this.toggleDropdown(), this.shouldAutoScroll = !0, this.handleClick(e);
    }, "aria-haspopup": "listbox", "aria-label": this.name, "aria-expanded": this.isOpen ? "true" : "false", onKeyDown: (e) => this.handleComboboxKeyDown(e), onInput: (e) => this.handleOnInput(e) }), this.isOpen ? n("div", { class: "dropdown-content", part: "id_dropdown-content", ref: (e) => this.optionsRef = e }, n("ul", { tabindex: "-1", role: "listbox", "aria-label": this.name, "aria-activedescendant": this.ariaActivedescendant, onKeyDown: (e) => this.handleListboxKeydown(e) }, this.filteredOptions.map((e) => n("li", { tabindex: "0", key: e.value, id: e.value, onClick: () => this.selectOption(e), role: "option", class: {
      focused: this.ariaActivedescendant === e.value.toString()
    } }, e.labelHTML ? e.labelHTML : e.label)))) : null);
  }
  get el() {
    return h(this);
  }
  static get watchers() {
    return {
      options: ["optionsChangedHandler"],
      defaultInputOption: ["defaultSelectedOptionChangedHandler"],
      inputValue: ["inputValueChangedHandler"]
    };
  }
};
b.style = m;
const y = ".time-period-selector.sc-time-period-selector{display:grid;gap:0.5rem;grid-template-columns:auto 1fr}.time-period-selector.sc-time-period-selector select-dropdown.sc-time-period-selector,.time-period-selector.sc-time-period-selector input-dropdown.sc-time-period-selector{border:1px solid var(--nylas-base-200);border-radius:var(--nylas-border-radius-2x)}.time-period-selector.sc-time-period-selector select-dropdown.sc-time-period-selector{width:116px}.time-period-selector.sc-time-period-selector input-dropdown.sc-time-period-selector{width:84px;display:flex;align-items:center}.time-period-selector.sc-time-period-selector select-dropdown#time-period.sc-time-period-selector::part(sd_dropdown-button){width:100%}.time-period-selector.sc-time-period-selector input-dropdown.sc-time-period-selector::part(id_dropdown){width:inherit;height:100%}.time-period-selector.sc-time-period-selector input-dropdown#time-number.sc-time-period-selector::part(id_dropdown-input){border:none;border-radius:var(--nylas-border-radius-2x)}.time-period-selector.sc-time-period-selector input-dropdown#time-number.error.sc-time-period-selector::part(id_dropdown-input){border:1px solid var(--nylas-error)}.time-period-selector.sc-time-period-selector input-dropdown.sc-time-period-selector:hover{outline:1px solid var(--nylas-primary);border:none}.time-period-selector.sc-time-period-selector input-dropdown.sc-time-period-selector::part(id_dropdown-input){padding:16px;gap:1rem}.time-period-selector.sc-time-period-selector input-dropdown.sc-time-period-selector::part(id_dropdown-input):hover{border:none;outline:none}.time-period-selector.sc-time-period-selector input-dropdown.sc-time-period-selector::part(id_dropdown-content){width:100%;max-height:200px}.time-period-selector.sc-time-period-selector select-dropdown.sc-time-period-selector::part(sd_dropdown){width:inherit;height:100%}.time-period-selector.sc-time-period-selector select-dropdown.sc-time-period-selector::part(sd_dropdown_label){height:100%}.time-period-selector.sc-time-period-selector select-dropdown.sc-time-period-selector::part(sd_dropdown-button){padding:1rem;gap:1rem;justify-content:space-between;border:none;align-items:center;height:100%}.time-period-selector.sc-time-period-selector select-dropdown.sc-time-period-selector::part(sd_dropdown-content){width:100%;max-height:200px}", g = y, w = {
  hours: "hour",
  days: "day",
  weeks: "week",
  months: "month",
  years: "year"
}, x = class {
  constructor(e) {
    p(this, e), this.timePeriodChanged = c(this, "timePeriodChanged", 7), this.timePeriods = u, this.defaultSelectedPeriod = void 0, this.defaultSelectedNumber = void 0, this.hasError = !1, this.selectedPeriod = this.defaultSelectedPeriod, this.selectedNumber = this.defaultSelectedNumber, this.numberOptions = this.calculateOptions(this.defaultSelectedPeriod || "hour").map((t) => ({
      label: t.toString(),
      value: t.toString()
    })), this.timePeriodOptions = this.timePeriods.map((t) => ({
      label: t.label,
      value: t.value
    }));
  }
  defaultSelectedPeriodChanged(e) {
    this.selectedPeriod = e, this.updateNumberOptionsAndSelectedNumber(e);
  }
  defaultSelectedNumberChanged(e) {
    this.selectedNumber = e;
  }
  timePeriodsChanged(e) {
    this.timePeriodOptions = [...e];
  }
  componentDidLoad() {
    this.selectedNumber = this.defaultSelectedNumber, this.selectedPeriod = this.defaultSelectedPeriod;
    const e = w[this.selectedPeriod] ?? this.selectedPeriod, t = this.calculateOptions(e);
    this.numberOptions = t.map((o) => ({
      label: o.toString(),
      value: o.toString()
    }));
  }
  calculateOptions(e) {
    switch (e) {
      case "hour":
        return Array.from({ length: 23 }, (t, o) => o + 1);
      case "minute":
        return Array.from({ length: 13 }, (t, o) => o * 5);
      case "day":
        return Array.from({ length: 30 }, (t, o) => o + 1);
      case "week":
        return Array.from({ length: 4 }, (t, o) => o + 1);
      case "month":
        return Array.from({ length: 12 }, (t, o) => o + 1);
      case "year":
        return Array.from({ length: 10 }, (t, o) => o + 1);
      default:
        return [];
    }
  }
  inputOptionChangedHandler(e) {
    l("time-period-selector", "inputOptionChangedHandler", e.detail);
    const { value: t, name: o } = e.detail;
    o === "time-number" && (this.selectedNumber = t ? parseInt(t) : this.defaultSelectedNumber);
    const i = {
      number: this.selectedNumber,
      period: this.selectedPeriod
    };
    this.timePeriodChanged.emit(i);
  }
  nylasFormDropdownChangedHandler(e) {
    l("time-period-selector", "nylasFormDropdownChangedHandler", e.detail);
    const { value: t, name: o } = e.detail;
    o === "time-period" ? (this.selectedPeriod = t, this.updateNumberOptionsAndSelectedNumber(t)) : o === "time-number" && (this.selectedNumber = parseInt(t));
    const i = {
      number: this.selectedNumber,
      period: this.selectedPeriod
    };
    this.timePeriodChanged.emit(i);
  }
  updateNumberOptionsAndSelectedNumber(e) {
    const t = this.calculateOptions(e);
    this.numberOptions = t.map((o) => ({
      label: o.toString(),
      value: o.toString()
    }));
  }
  render() {
    var e;
    return n("div", { key: "2d3fa137ee903ba33becbb66802dcfced2b7ee09", class: "time-period-selector" }, typeof this.selectedNumber == "number" && n("input-dropdown", { id: "time-number", name: "time-number", class: { error: this.hasError }, inputValue: this.selectedNumber.toString(), exportparts: "id_dropdown: tps__number-dropdown, id_dropdown-input: tps__number-dropdown-button, id_dropdown-content: tps__number-dropdown-content", options: this.numberOptions, defaultInputOption: this.numberOptions.find((t) => t.value == this.selectedNumber.toString()) }), typeof this.selectedPeriod == "string" && n("select-dropdown", { id: "time-period", name: "time-period", options: this.timePeriodOptions, exportparts: "sd_dropdown: tps__period-dropdown, sd_dropdown-button: tps__period-dropdown-button, sd_dropdown-content: tps__period-dropdown-content", pluralizedLabel: this.selectedNumber > 1 ? a.t(`time.${this.selectedPeriod}s`) : a.t(`time.${this.selectedPeriod}`), defaultSelectedOption: (e = this.timePeriodOptions) == null ? void 0 : e.find((t) => t.value == this.selectedPeriod), withSearch: !1 }));
  }
  get host() {
    return h(this);
  }
  static get watchers() {
    return {
      defaultSelectedPeriod: ["defaultSelectedPeriodChanged"],
      defaultSelectedNumber: ["defaultSelectedNumberChanged"],
      timePeriods: ["timePeriodsChanged"]
    };
  }
};
x.style = g;
export {
  b as input_dropdown,
  x as time_period_selector
};
